/*
  Adds the promise polyfill for IE 11
*/
require('es6-promise').polyfill();

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { users } from './modules/users'

import { groups } from './modules/groups'
import { departments } from './modules/departments'
import { years } from './modules/years'
import { rates } from './modules/rates'
import { courses } from './modules/courses'
import { children } from './modules/children'
import { owners } from './modules/owners'
import { presences } from './modules/presences'
import { settlements } from './modules/settlements'
import { dashboards } from './modules/dashboards'
import { payments } from './modules/payments'
import { reports } from './modules/reports'

import SharedAPI from "./api/shared";

export default new Vuex.Store({
  modules: {
    users,
    groups,
    departments,
    years,
    rates,
    courses,
    children,
    owners,
    presences,
    settlements,
    dashboards,
    payments,
    reports
  },
  state: {
    nfcStatus:"NO_EXTENSION",
    lookups:{
        permissions: [
            { value: 0, text: "Brak dostępu" },
            { value: 5, text: "Dostęp ograniczony" },
            { value: 10, text: "Pełny dostęp" },
            { value: 20, text: "Administrator" }
        ],
        childlog:[
          { value: 1, text: "Utworzenie dziecka" },
          { value: 2, text: "Edycja danych dziecka" },
          { value: 3, text: "Wyłączenie dziecka" },
          { value: 4, text: "Włączenie dziecka" },
          { value: 5, text: "Usunięcie dziecka" },
          { value: 21, text: "Przypisanie do grupy" },
          { value: 22, text: "Zmiana grupy" },
          { value: 23, text: "Wypisanie z grupy" },
          { value: 31, text: "Utworzenie opiekuna" },
          { value: 32, text: "Edycja danych opiekuna" },
          { value: 33, text: "Skopiowanie opiekuna" },
          { value: 35, text: "Usunięcie opiekuna" },
          { value: 41, text: "Przypisanie cennika" },
          { value: 42, text: "Zmiana cennika" },
          { value: 43, text: "Edycja danych cennika" },
          { value: 51, text: "Dodanie powiązanego konta" },
          { value: 55, text: "Usunięcie powiązanego konta" },
        ],
        childLogParams:[
          { value:'name',text: 'Imię'},
          { value:'surname',text: 'Nazwisko'},
          { value:'birth_year',text: 'Rocznik'},
          { value:'note',text: 'Dodatkowe informacje'},
          { value:'diet',text: 'Dieta'},
          { value:'diet_note',text: 'Opis diety'},
          { value:'pickup',text: 'Wymagane wskazanie odoby odbierającej'},
          { value:'rate.document',text: 'Nr dokumentu'},
          { value:'rate.expiry',text: 'Data ważności dokumentu'},
          { value:'owner.name',text: 'Imię i nazwisko'},
          { value:'owner.role',text: 'Rola'},
          { value:'owner.mobile',text: 'Nr telefonu'},
          { value:'owner.email',text: 'Adres e-mail'},
          { value:'owner.card',text: 'Nr karty'},
          { value:'owner.permission',text: 'Dostarczenie zgody'},
          { value:'owner.document',text: 'Nr dokumentu'},
          { value:'owner.expiry',text: 'Data ważności zgody'},
        ],
        roles: [
          { value: 0, text: "Mama" },
          { value: 5, text: "Tata" },
          { value: 10, text: "Rodzina" },
          { value: 20, text: "Znajomi" }
        ],
        reasons: [
          { value: 0, text: "Choroba" },
          { value: 5, text: "Wyjazd" },
          { value: 10, text: "Wagary" },
          { value: 20, text: "Inny" }
        ],
        settlementsStatus: [
          { value: 0, text: "Brak" },
          { value: 5, text: "Nierozliczone" },
          { value: 10, text: "Rozliczone(niedopłata)" },
          { value: 11, text: "Rozliczone(nadpłata)" },
          { value: 20, text: "Rozliczone" },
          { value: 25, text: "Błąd" },
        ],
        paymentsStatus: [
          //{ value: 0, text: "Brak" },
          { value: 5, text: "Zatwierdzony" },
          { value: 10, text: "Raport Kasowy" },
          { value: 20, text: "Storno" },
          { value: 25, text: "Zamknięty" },
          { value: 30, text: "Usunięty" },
        ],
        freeHours: [
          //{ value: 0, text: "Brak" },
          { value: "7:30-12:30", text: "7:30-12:30" },
          { value: "8:00-13:00", text: "8:00-13:00" },
          { value: "8:30-13:30", text: "8:30-13:30" },
        ],
        tolerances: [
          //{ value: 0, text: "Brak" },
          { value: 0, text: "0 min - Brak" },
          { value: 5, text: "5 min" },
          { value: 10, text: "10 min" },
          { value: 15, text: "15 min" },
        ],
        months:[
          { value: 1, text: "Styczeń" },
          { value: 2, text: "Luty" },
          { value: 3, text: "Marzec" },
          { value: 4, text: "Kwiecień" },
          { value: 5, text: "Maj" },
          { value: 6, text: "Czerwiec" },
          { value: 7, text: "Lipiec" },
          { value: 8, text: "Sierpień" },
          { value: 9, text: "Wrzesień" },
          { value: 10, text: "Pażdziernik" },
          { value: 11, text: "Listopad" },
          { value: 12, text: "Grudzień" },
        ],
        notifications_status: [
          { value: 0, text: "Brak powiadomienia" },
          { value: 5, text: "Wysłano powiadomienie" },
          { value: 10, text: "Błąd wysyłania - brak adresu e-mail" },
          
      ],
        rate_categories: [
          { value: 1, text: "Grupa 1" },
          { value: 2, text: "Grupa 2" },
          { value: 3, text: "Grupa 3" },
          
        ],
        groups:[],
        departments:[],
        users:[],
        years:[],
        rates:[],
        courses:[],
        all_courses:[],
        my_courses:[],
    },
    lookupsLoadStatus: 0,

    menu:{
      desktop:{},
      settings:{},
      dictionaries:{},
    },
    menuCountLoadStatus: 0,
    brightness:null,
  },
  actions: {
    loadMenuSettingsCount({ commit, dispatch }) {
      commit("setMenuCountLoadStatus", 1);

      SharedAPI.getMenuSettingsCount()
          .then(function(response) {
              commit("setMenuSettingsCount", response.data);
              commit("setMenuCountLoadStatus", 2);
          })
          .catch(function() {
              commit("setMenuSettingsCount", {});
              commit("setMenuCountLoadStatus", 3);
          });
    },
    loadMenuDictionariesCount({ commit, dispatch }) {
      commit("setMenuCountLoadStatus", 1);

      SharedAPI.getMenuDictionariesCount()
          .then(function(response) {
              commit("setMenuDictionariesCount", response.data);
              commit("setMenuCountLoadStatus", 2);
          })
          .catch(function() {
              commit("setMenuDictionariesCount", {});
              commit("setMenuCountLoadStatus", 3);
          });
    },
    loadMenuDesktopCount({ commit, dispatch }) {
      commit("setMenuCountLoadStatus", 1);

      SharedAPI.getMenuDesktopCount()
          .then(function(response) {
              commit("setMenuDesktopCount", response.data);
              commit("setMenuCountLoadStatus", 2);
          })
          .catch(function() {
              commit("setMenuDesktopCount", {});
              commit("setMenuCountLoadStatus", 3);
          });
    },
    loadLookups({ commit }) {
        commit("setLookupsLoadStatus", 1);

        SharedAPI.getLookups()
            .then(function(response) {
                commit("setGroupsLookup", response.data.groups);
                commit("setDepartmentsLookup", response.data.departments);
                commit("setUsersLookup", response.data.users);
                commit("setYearsLookup", response.data.years);
                commit("setRatesLookup", response.data.rates);
                commit("setCoursesLookup", response.data.courses);
                commit("setAllCoursesLookup", response.data.all_courses);
                commit("setMyCoursesLookup", response.data.my_courses);
                commit("setLookupsLoadStatus", 2);
            })
            .catch(function() {
                commit("setGroupsLookup", []);
                commit("setDepartmentsLookup", []);
                commit("setUsersLookup", []);
                commit("setLookupsLoadStatus", 3);
            });
    },
    loadGroupLookup({ commit }) {
      commit("setLookupsLoadStatus", 1);
      
      SharedAPI.getGroupLookup()
          .then(function(response) {
              commit("setGroupsLookup", response.data);
              commit("setLookupsLoadStatus", 2);
          })
          .catch(function() {
              commit("setGroupsLookup", []);
              commit("setLookupsLoadStatus", 3);
          });
    },
    loadDepartmentLookup({ commit }) {
      commit("setLookupsLoadStatus", 1);
      
      SharedAPI.getDepartmentLookup()
          .then(function(response) {
              commit("setDepartmentsLookup", response.data);
              commit("setLookupsLoadStatus", 2);
          })
          .catch(function() {
              commit("setDepartmentsLookup", []);
              commit("setLookupsLoadStatus", 3);
          });
    },
    loadUserLookup({ commit }) {
      commit("setLookupsLoadStatus", 1);
      
      SharedAPI.getUserLookup()
          .then(function(response) {
              commit("setUsersLookup", response.data);
              commit("setLookupsLoadStatus", 2);
          })
          .catch(function() {
              commit("setUsersLookup", []);
              commit("setLookupsLoadStatus", 3);
          });
    },
    loadYearLookup({ commit }) {
      commit("setLookupsLoadStatus", 1);
      
      SharedAPI.getYearLookup()
          .then(function(response) {
              commit("setYearsLookup", response.data);
              commit("setLookupsLoadStatus", 2);
          })
          .catch(function() {
              commit("setYearsLookup", []);
              commit("setLookupsLoadStatus", 3);
          });
    },
    loadRateLookup({ commit }, data) {
      commit("setLookupsLoadStatus", 1);
      
      SharedAPI.getRateLookup(data.year_id)
          .then(function(response) {
              commit("setRatesLookup", response.data);
              commit("setLookupsLoadStatus", 2);
          })
          .catch(function() {
              commit("setRatesLookup", []);
              commit("setLookupsLoadStatus", 3);
          });
    },
    loadCourseLookup({ commit }, data) {
      commit("setLookupsLoadStatus", 1);
      
      SharedAPI.getCourseLookup(data.year_id  )
          .then(function(response) {
              commit("setCoursesLookup", response.data);
              commit("setLookupsLoadStatus", 2);
          })
          .catch(function() {
              commit("setCoursesLookup", []);
              commit("setLookupsLoadStatus", 3);
          });
    },

  },
  mutations: {
    setNfcStatus(state,status){
      state.nfcStatus = status;
    },
    setBrightness( state, brightness ){
      state.brightness = brightness;
    },
    setMenuDesktopCount(state, settings) {
      state.menu.desktop = settings;
    },
    setMenuSettingsCount(state, settings) {
      state.menu.settings = settings;
    },
    setMenuDictionariesCount(state, dictionaries) {
      state.menu.dictionaries = dictionaries;
    },
    setMenuCountLoadStatus(state, status) {
        state.menuCountLoadStatus = status;
    },
    setLookupsLoadStatus(state,status){
      state.lookupsLoadStatus = status;
    },
    setGroupsLookup(state,data){
      let local= data;
      local.forEach(l => {
          l.value = parseInt(l.value);
          
      });
      state.lookups.groups = local;
    },
    setDepartmentsLookup(state,data){
      let local= data;
      local.forEach(l => {
          l.value = parseInt(l.value);
      });
      state.lookups.departments = local;
    },
    setUsersLookup(state,data){
      let local= data;
      local.forEach(l => {
          l.value = parseInt(l.value);
      });
      state.lookups.users = local;
    },
    setYearsLookup(state,data){
      let local= data;
      local.forEach(l => {
          l.value = parseInt(l.value);
          l.default = parseInt(l.default);
          l.year_from = parseInt(l.year_from);
          l.year_to = parseInt(l.year_to);
          if(l.default){
            state.rates.rateOptions.selectedYear = l.value;
            state.rates.rateEdit.year_id = l.value;
            state.rates.rateEditDefault.year_id = l.value;
            state.courses.courseOptions.selectedYear = l.value;
            state.courses.courseEdit.year_id = l.value;
            state.courses.courseEditDefault.year_id = l.value;
            state.children.childOptions.selectedYear = l.value;
            state.children.childEdit.year_id = l.value;
            state.children.childEditDefault.year_id = l.value;
            state.presences.presenceOptions.selectedYear = l.value;
            state.reports.hoursByRateOptions.selectedYear = l.value;
          }
      });
      state.lookups.years = local;
    },
    setRatesLookup(state,data){
      let local= data;
      local.forEach(l => {
          l.value = parseInt(l.value);
      });
      state.lookups.rates = local;
    },
    setCoursesLookup(state,data){
      let local= data;
      local.forEach(l => {
          l.value = parseInt(l.value);
          l.display = l.text;
      });
      // if(local.length>0){
      state.presences.presenceOptions.selectedCourse = 0;
      // }
      state.lookups.courses = local;
    },
    setAllCoursesLookup(state,data){
      let local= data;
      local.forEach(l => {
          l.value = parseInt(l.value);
          l.display = l.text;
      });
      state.lookups.all_courses = local;
    },
    setMyCoursesLookup(state,data){
      let local= data;
      local.forEach(l => {
          l.value = parseInt(l.value);
          l.display = l.text;
      });
      state.lookups.my_courses = local;
    },
  },
  getters: {
    getNfcStatus(state){
      return function(){
        return state.nfcStatus;
      }
    },
    getBrightness( state ){
      return state.brightness;
    },
    getMenu(state) {
      return state.menu;
    },
    getMenuCountLoadStatus(state) {
        return state.menuCountLoadStatus;
    },
    getLookups(state){
      return state.lookups;
    },
    getLookupsLoadStatus(state){
      return state.lookupsLoadStatus;
    }
  }
})
